const { useRef } = require("react");

export default function ImageUploadButton({ onChange, children }) {
  const inputRef = useRef();

  return (
    <span
      onClick={() => inputRef.current?.click()}
      style={{ cursor: "pointer" }}
    >
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        multiple
        style={{ display: "none" }}
        onChange={(e) => {
          const files = Array.from(e.target.files);
          if (files?.length && onChange) onChange(files);
        }}
      />
      {children}
    </span>
  );
}
